import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MScorescreen } from "components/Shared";
import { getCustomerScorecardData } from 'actions/customer';

class CustomerScorecard extends React.Component {

  componentDidMount() {
    const {getCustomerScorecardData} = this.props;
    getCustomerScorecardData();
  }

  render() {
    const {customerScorecardData} = this.props;
    return <MScorescreen scorecardData={customerScorecardData}/>;
  }
}

CustomerScorecard.defaultProps = {
  customerNumber: 1024,
};

CustomerScorecard.propTypes = {

  //Pure Props
  customerNumber: PropTypes.oneOfType([
    PropTypes.number, PropTypes.string,
  ]),

  //Redux State
  customerScorecardData: PropTypes.object,

  //Redux Actions
  getCustomerScorecardData: PropTypes.func,
};

const mstp = state => ({
  customerScorecardData: state.homeownerCustomer.customerScorecardData,
});

const mdtp = dispatch => ({
  getCustomerScorecardData() {
    dispatch(getCustomerScorecardData());
  }
});

export default connect(mstp, mdtp)(CustomerScorecard);